import React, { useContext, useState } from "react";
import { NavLink } from "react-router-dom";
import { GlobalContext } from "../../context/globalContext";
import { logoutUserAPI } from "../../api/auth";
import { isSuperAdminRole } from "../../api/admin";

const Header: React.FC = () => {
  const { currentUser, setCurrentUser, isAuthLoading } =
    useContext(GlobalContext);
  const [showUserDropdown, setShowUserDropdown] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  async function handleUserLogout() {
    try {
      setIsLoggingOut(true);
      const response = await logoutUserAPI();
      if (response && response.ok) {
        setCurrentUser(null);
        window.location.href = "/";
      }
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoggingOut(false);
    }
  }

  const displayName =
    currentUser?.firstName?.trim() ||
    currentUser?.email?.split("@")[0] ||
    "Account";

  return (
    <header className="w-full h-header box-border flex justify-between items-center px-6 fixed top-0 bg-white/95 backdrop-blur border-b border-slate-200 z-[99999]">
      <NavLink
        to="/"
        className="flex items-center gap-3 font-bold text-slate-900 tracking-tight hover:text-slate-700 transition-colors"
      >
        Events House
      </NavLink>

      <ul className="flex gap-4 items-center text-sm">
        {isAuthLoading ? (
          <li className="opacity-0 select-none">Loading</li>
        ) : currentUser?.email ? (
          <li
            className="relative"
            onMouseEnter={() => setShowUserDropdown(true)}
            onMouseLeave={() => setShowUserDropdown(false)}
          >
            <button
              type="button"
              className="flex items-center gap-2 px-3 py-1.5 rounded-sm border border-slate-200 bg-slate-50 text-slate-800 font-medium hover:bg-slate-100 transition-colors"
              aria-expanded={showUserDropdown ? "true" : "false"}
              aria-haspopup="true"
            >
              <span className="w-7 h-7 rounded-full bg-slate-800 text-white text-xs font-bold flex items-center justify-center uppercase">
                {displayName.charAt(0)}
              </span>
              <span className="hidden sm:inline max-w-[140px] truncate">
                {displayName}
              </span>
            </button>

            {showUserDropdown && (
              <div className="absolute top-full right-0 pt-2 min-w-[220px]">
                <div className="border border-slate-200 rounded-sm bg-white shadow-lg py-2 text-sm">
                  <p className="px-4 py-2 text-xs text-slate-500 border-b border-slate-100 truncate">
                    {currentUser.email}
                  </p>
                  <NavLink
                    to="/user/dashboard"
                    className="block px-4 py-2.5 text-slate-800 hover:bg-slate-50 font-medium"
                  >
                    Dashboard
                  </NavLink>
                  <NavLink
                    to="/user/orders"
                    className="block px-4 py-2.5 text-slate-800 hover:bg-slate-50"
                  >
                    Orders &amp; registrations
                  </NavLink>
                  <NavLink
                    to="/user/account"
                    className="block px-4 py-2.5 text-slate-800 hover:bg-slate-50"
                  >
                    Account
                  </NavLink>
                  {isSuperAdminRole(currentUser.role) && (
                    <NavLink
                      to="/user/administration"
                      className="block px-4 py-2.5 text-slate-800 hover:bg-slate-50"
                    >
                      Administration
                    </NavLink>
                  )}
                  {isSuperAdminRole(currentUser.role) && (
                    <NavLink
                      to="/user/paper-videos"
                      className="block px-4 py-2.5 text-slate-800 hover:bg-slate-50"
                    >
                      Paper Videos
                    </NavLink>
                  )}
                  <NavLink
                    to="/user/events"
                    className="block px-4 py-2.5 text-slate-800 hover:bg-slate-50"
                  >
                    Manage events
                  </NavLink>
                  <NavLink
                    to="/user/preferences"
                    className="block px-4 py-2.5 text-slate-800 hover:bg-slate-50"
                  >
                    Preferences
                  </NavLink>
                  <div className="border-t border-slate-100 mt-1 pt-1">
                    <button
                      type="button"
                      onClick={handleUserLogout}
                      disabled={isLoggingOut}
                      className="w-full text-left px-4 py-2.5 text-slate-600 hover:bg-slate-50 hover:text-slate-900"
                    >
                      {isLoggingOut ? "Signing out…" : "Sign out"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </li>
        ) : (
          <>
            <li>
              <NavLink
                to="/signup"
                className="text-slate-700 hover:text-slate-900 font-medium"
              >
                Sign up
              </NavLink>
            </li>
            <li>
              <NavLink
                className="eh-btn-primary px-4 py-1.5 text-sm font-medium"
                to="/login"
              >
                Sign in
              </NavLink>
            </li>
          </>
        )}
      </ul>
    </header>
  );
};

export default Header;
